"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-41985a3e"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = { class: "calling-wrapper" };
var _hoisted_2 = { class: "turn-icon-container" };
var _hoisted_3 = { class: "turn-icon-container" };
var _hoisted_4 = { class: "tag" };
var _hoisted_5 = { class: "microphone-icon-container" };
var _hoisted_6 = ["id"];
var _hoisted_7 = {
    key: 0,
    class: "user-view-text-container"
};
var _hoisted_8 = { class: "user-view-info" };
var _hoisted_9 = { class: "tag" };
var _hoisted_10 = { class: "microphone-icon-container" };
var index_1 = require("../store/index");
var vue_3 = require("vue");
var MicrophoneIcon_vue_1 = require("./MicrophoneIcon.vue");
var index_2 = require("../index");
var constants_1 = require("../constants");
var left_vue_1 = require("../icons/left.vue");
var right_vue_1 = require("../icons/right.vue");
var microphoneClosed_vue_1 = require("../icons/microphoneClosed.vue");
exports.default = vue_1.defineComponent({
    __name: 'Calling-Group',
    setup: function (__props) {
        var _this = this;
        var currentPage = vue_3.ref(1);
        var currentPageRemoteList = vue_3.ref([]);
        var groupUserViewClass = vue_3.ref("group-user-view");
        var groupCallingContainerClass = vue_3.ref("group-calling-container");
        var userViewUserId = vue_3.ref("user-view-user-id");
        vue_3.onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(index_1.status.value === constants_1.STATUS.CALLING_GROUP_VIDEO || index_1.status.value === constants_1.STATUS.CALLING_GROUP_AUDIO)) return [3 /*break*/, 2];
                        return [4 /*yield*/, index_2.TUICallKitServer.renderLocal()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, index_2.TUICallKitServer.renderRemoteWaitList()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        vue_3.watch(currentPageRemoteList, function () { return __awaiter(_this, void 0, void 0, function () {
            var userViewCount;
            return __generator(this, function (_a) {
                userViewCount = currentPageRemoteList.value.length + 1;
                groupUserViewClass.value = "group-user-view group-user-view-" + userViewCount;
                groupCallingContainerClass.value = "group-calling-container group-calling-container-" + userViewCount;
                userViewUserId.value = "user-view-user-id user-view-user-id-" + userViewCount;
                index_2.TUICallKitServer.renderRemoteList(currentPageRemoteList.value);
                return [2 /*return*/];
            });
        }); }, { flush: 'post', deep: true });
        vue_3.watchEffect(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, refreshCurrentPageRemoteList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        function refreshCurrentPageRemoteList() {
            return __awaiter(this, void 0, void 0, function () {
                var newPageList, i;
                return __generator(this, function (_a) {
                    newPageList = [];
                    for (i = (currentPage.value - 1) * 8; i < (currentPage.value) * 8 && i < index_1.remoteList.value.length; i++) {
                        newPageList.push(index_1.remoteList.value[i]);
                    }
                    currentPageRemoteList.value = newPageList;
                    return [2 /*return*/];
                });
            });
        }
        function pageReduce() {
            if (currentPage.value > 1) {
                currentPage.value--;
            }
        }
        function pageIncrease() {
            if (currentPage.value < Math.floor((index_1.remoteList.value.length - 1) / 8 + 1)) {
                currentPage.value++;
            }
        }
        return function (_ctx, _cache) {
            var _a, _b;
            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                (vue_2.unref(index_1.remoteList).length > 8)
                    ? (vue_2.openBlock(), vue_2.createElementBlock(vue_2.Fragment, { key: 0 }, [
                        vue_2.createElementVNode("div", {
                            class: "page-turn left",
                            onClick: pageReduce
                        }, [
                            vue_2.createElementVNode("div", _hoisted_2, [
                                vue_2.createVNode(left_vue_1.default)
                            ])
                        ]),
                        vue_2.createElementVNode("div", {
                            class: "page-turn right",
                            onClick: pageIncrease
                        }, [
                            vue_2.createElementVNode("div", _hoisted_3, [
                                vue_2.createVNode(right_vue_1.default)
                            ])
                        ])
                    ], 64))
                    : vue_2.createCommentVNode("", true),
                vue_2.createElementVNode("div", {
                    class: vue_2.normalizeClass(groupCallingContainerClass.value)
                }, [
                    vue_2.createElementVNode("div", {
                        id: "local-group",
                        class: vue_2.normalizeClass(groupUserViewClass.value)
                    }, [
                        vue_2.createElementVNode("span", _hoisted_4, [
                            vue_2.createElementVNode("div", _hoisted_5, [
                                ((_a = vue_2.unref(index_1.profile)) === null || _a === void 0 ? void 0 : _a.microphone)
                                    ? (vue_2.openBlock(), vue_2.createBlock(MicrophoneIcon_vue_1.default, {
                                        key: 0,
                                        volume: vue_2.unref(index_1.getVolumeByUserID)(vue_2.unref(index_1.profile).userID)
                                    }, null, 8, ["volume"]))
                                    : (vue_2.openBlock(), vue_2.createBlock(microphoneClosed_vue_1.default, { key: 1 }))
                            ]),
                            vue_2.createTextVNode(" " + vue_2.toDisplayString(((_b = vue_2.unref(index_1.profile)) === null || _b === void 0 ? void 0 : _b.nick) + " " + vue_2.unref(index_1.t)('me')), 1)
                        ])
                    ], 2),
                    (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(currentPageRemoteList.value, function (remoteUserItem) {
                        return (vue_2.openBlock(), vue_2.createElementBlock("div", {
                            class: vue_2.normalizeClass(groupUserViewClass.value),
                            id: remoteUserItem.userID,
                            key: remoteUserItem.userID
                        }, [
                            (!remoteUserItem.isEntered || (vue_2.unref(index_1.isFromGroup) && vue_2.unref(index_1.callType) === vue_2.unref(constants_1.CALL_TYPE_STRING).AUDIO))
                                ? (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_7, [
                                    vue_2.createElementVNode("div", {
                                        class: vue_2.normalizeClass(userViewUserId.value)
                                    }, vue_2.toDisplayString(remoteUserItem === null || remoteUserItem === void 0 ? void 0 : remoteUserItem.nick), 3),
                                    vue_2.createElementVNode("div", _hoisted_8, vue_2.toDisplayString(remoteUserItem.isEntered ? vue_2.unref(index_1.t)('already-enter') : vue_2.unref(index_1.t)('waiting')), 1)
                                ]))
                                : vue_2.createCommentVNode("", true),
                            vue_2.createElementVNode("span", _hoisted_9, [
                                vue_2.createElementVNode("div", _hoisted_10, [
                                    (remoteUserItem === null || remoteUserItem === void 0 ? void 0 : remoteUserItem.microphone)
                                        ? (vue_2.openBlock(), vue_2.createBlock(MicrophoneIcon_vue_1.default, {
                                            key: 0,
                                            volume: vue_2.unref(index_1.getVolumeByUserID)(remoteUserItem === null || remoteUserItem === void 0 ? void 0 : remoteUserItem.userID)
                                        }, null, 8, ["volume"]))
                                        : (vue_2.openBlock(), vue_2.createBlock(microphoneClosed_vue_1.default, { key: 1 }))
                                ]),
                                vue_2.createTextVNode(" " + vue_2.toDisplayString(remoteUserItem === null || remoteUserItem === void 0 ? void 0 : remoteUserItem.nick), 1)
                            ])
                        ], 10, _hoisted_6));
                    }), 128))
                ], 2)
            ]));
        };
    }
});
